<div class="p-p-2">
    <span class="p-float-label" >
      <p-inputNumber
        [(ngModel)]="value"
        [ngClass]="ngClass"
        inputId="minmax"
        inputId="minmax"
        mode="decimal"
        [min]="min"
        [max]="max"
        [useGrouping]="useGrouping"
        [minFractionDigits]="minFractionDigits"
        [maxFractionDigits]="maxFractionDigits"
        (onTouched)="onTouched()"
        (ngModelChange)="onChange()"
        [size]="size"
        [disabled]="disabled"
      >
      </p-inputNumber>    
      <label>{{ label | translate }}</label>
    </span>
  </div>
